import { IPayByLinkData } from '@ace-clublabs/payment-types';
import { NavigateFunction } from 'react-router-dom';
import { Pages } from '../shared/pages';
import { ErrorType } from '../shared/types';
import LogCannon from '@ace-clublabs/log-cannon';

export const isPBLExpired = (payByLinkData?: IPayByLinkData): boolean => {
  if (!payByLinkData?.paymentLinkExpiryDateUTC) {
    return false;
  }

  const expiryDate = Date.parse(payByLinkData.paymentLinkExpiryDateUTC);
  if (isNaN(expiryDate)) {
    LogCannon.blast('PBL: Invalid expiry date format', {
      paymentLinkExpiryDateUTC: payByLinkData.paymentLinkExpiryDateUTC,
    });
    return false;
  }

  const currentTime = Date.now();
  return expiryDate <= currentTime;
};

export const validatePBLExpiration = (
  payByLinkData: IPayByLinkData | undefined,
  navigate: NavigateFunction,
  setError: (error: { errorMessage: string; errorType: ErrorType }) => void
): void => {
  if (isPBLExpired(payByLinkData)) {
    LogCannon.blast('PBL: Link expired, redirecting to error page', {
      paymentLinkExpiryDateUTC: payByLinkData?.paymentLinkExpiryDateUTC,
      currentTime: new Date().toISOString(),
    });

    setError({
      errorMessage: 'This payment link has expired. Please contact your agent for a new link.',
      errorType: ErrorType.PBL_EXPIRED,
    });

    LogCannon.blast('Navigating to Error', {
      component: 'pblExpirationHelper',
      errorMessage: 'This payment link has expired. Please contact your agent for a new link.',
      error: ErrorType.PBL_EXPIRED,
    });
    navigate(Pages.Error);
  }
};
